//@ts-ignore
import React, { Component } from 'react';
import {
    MyPATTextArea,
    MyPATExpansionPanel,
    MyPATMathField,
    MyPATDialog,
    MyPATLink,
    MyPatVideoPlayer,
    TimePicker,
    SearchField,
    MyPATFileUpload,
    MyPATMultiSearch

} from "../../../common";
import StudyVideoCreate from './VideoCreate/StudyVideoCreate';
import { statusType } from '../../types/ContentInSection';
import MyPatThumbnail from '../../../common/MyPatThumbnail'
import PlayCircleOutlineTwoToneIcon from '@material-ui/icons/PlayCircleOutlineTwoTone';
import CloseIcon from '@material-ui/icons/Close';
import AddConceptOrChapter from './AddConceptOrChapter';
import DeletePopUp from './wrapperComponent/popUps';
import AddExtraTags from './AddExtraTags';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    Typography, createStyles, WithStyles, Button, Grid, FormControlLabel, Checkbox, FormGroup,
    Dialog,
    DialogTitle,
    DialogContent,
    Link,
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    NavigateBeforeOutlined as BackIcon,
    ReorderOutlined as ReorderIcon,
    Delete as DeleteIcon,
    SwapHoriz as ReplaceIcon,
} from "@material-ui/icons";
import WithContent from "../../containers/WithContent";
import { videoDetailsActions } from '../../reducers/addDetailsVideoReducer';
import ContentFormDataError from '../../types/ContentFormDataError';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { showMsg } from '../../../course/actions/loaderAlert';
import contentService from '../../services/contentService';
import videoUploadService from '../../services/videoUploadService';
import config from '../../../../config/config';
import { videoActions } from '../../reducers/videoCreateContentReducers';
import { getKeyFromStreamUrl, getThumbnailSource } from '../../../../utils';
import { CONTENT_STATES, CONTENT_TYPE, VIDEO_UPLOAD_MODES } from '../../../../constants/comman';
import ContentData from '../../types/ContentData';
import * as JSLZString from 'lz-string';
const updater = (action: string, value: number) => {
    switch (action) {
        case "INCREMENT":
            return value + 1;
        case "DECREMENT":
            return value - 1;
        default:
            return null;
    }
};

const styles = (theme: Theme) => createStyles({
    root: {
        flex: 'grow'
    },
    suggestList: {
        left: '0',
        background: '#fff',
        boxShadow: '0px 0px 2px #ccc',
        padding: 0,
        zIndex: 10,
        listStyleType: 'none',
        width: '100%',
    },
    suggestItem: {
        padding: theme.spacing.unit,
        paddingBottom: theme.spacing.unit + 4,
        cursor: 'pointer',
        zIndex: 11,
        '&::after': {
            clear: 'both',
        }
    },
    mybtnGroup: {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "60% 40%",
        "& button": {
            maxWidth: "150px",
            width: "100%",
            height: "40px",
            lineHeight: "30px",
            textAlign: "center",
            marginBottom: "-10px",
        }
    },
    tabsAlign: {
        display: 'block',
        "& p": {
            padding: '10px',
        },
        '& textarea':{
            padding: '0 12px',

        },
    },
    closeIcon: {
        justifyContent: 'flex-end !important'
    },
    textAlignRight: {
        textAlign: "right"
    },
    dInlineB:{
        '& a':{
            display: 'inline-block!important'
        }
    },
    addButtonAlign: {
        display: 'flex',
        alignContent: 'center',
        flexDirection: 'row-reverse'
    },
    chooseFromLibraryButton: {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'space-around'

    },
    mb1x: {
        marginBottom: theme.spacing.unit
    },
    questionParagraph: {
        maxWidth: 380,
        '& >p': {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            margin: '0',
        }
    },
    questionInfo: {
        border: `1px solid ${theme.palette.grey[300]}`,
        "& > div": {
            padding: `0 ${theme.spacing.unit}px`
        },
        "& > div:first-child": {
            paddingTop: theme.spacing.unit,
            paddingBottom: theme.spacing.unit,
            borderRight: `1px solid ${theme.palette.grey[300]}`
        }
    },
    optionContent: {
        "& .btn-delete": {
            visibility: "visible"
        },
        '& p>img': {
            maxWidth: '100%'
        }
    },
    questionActionBtn: {
        padding: theme.spacing.unit * 2,
        minWidth: "42px",
        minHeight:"42px",
        border: "1px solid #DFDFDF",
        color: theme.palette.text.secondary,
        borderRadius: 4,
        position:'absolute',
        right:'20px',
        top:' 85px',
    },
    noPosition:{
        position: 'inherit'
    },
    buttonAlign: {
        display: 'flex',
        alignContent: 'center',
    },

    notesBlockTitle: {
        fontSize: 20,
        fontWeight: 400,
        paddingTop: 20,
    },
    addQuestionTitle: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: 'Nunito',
    },
    tabsNotes: {
        fontSize: 16,
        fontWeight: 400,
        padding: 0,
        marginBottom: '15px',
    },
    tabsContainer: {
        border: 'solid 1px #E1E1E1',
        margin: '0 0 10px 0',
        // marginTop: '-30px',
        padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 20,
            color: "#333333",
            position: 'initial',
            marginBottom: 12,
        },
    },
    tabsContainer2: {
        border: 'solid 1px #E1E1E1',
        margin: '5px 0 10px 0',
        padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 20,
            lineHeight: "22px",
            color: "#333333",
        },
    },
    searchNotesinput: {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        padding: `0 ${theme.spacing.unit}px`,
    },
    OrDivider: {
        margin: "25px 0",
        display: "block",
        position: "relative",
        textAlign: "center",
        height: "50px",
        zIndex: 0,
    },
    orText: {
        background: "#E0E6E7",
        height: "40px",
        width: "40px",
        borderRadius: "100%",
        fontStyle: "italic",
        fontSize: 14,
        color: "#989898",
        display: "inline-block",
        paddingTop: "8px",
        "position": "absolute",
        "top": "-20px",
        left: '47%',
    },
    dividerBar: {
        "position": "absolute",
        "left": 0,
        "top": "15px",
        width: "100%",
        "content": " ",
        height: "1px",
        background: "#E0E6E7",
        "z-index": "1",
    },
    textAlignCenter: {
        textAlign: "center",
    },

    addPageMore: {
        background: '#FFF !important',
        color: '#1D7DEA !important',
        marginRight: 6,
        boxSizing: 'border-box',
        borderRadius: 4,
        fontWeight: 600,
        fontSize: '0.875rem',
    },
    seachQuestionText: {
        fontSize: 16,
        fontWeight: 400,
        padding: 0,
    },
    containerBorder: {

    },
    imgSearch: {
        "position": "absolute",
        "left": "30px",
        "top": "54px",
        "z-index": "1",
    },
    ". MuiTab-root-355": {
        fontSize: "1.25rem !important",
    },
    selectedQues: {
        paddingRight: '20px',
    },
    dialogContent: {
        padding: 0,
        maxHeight: '100%',
        marginTop: 74
    },
    mandatory: {
        color: 'red',
    },
    ".MuiPrivateTabIndicator-colorPrimary-343": {
        backgroundColor: 'none !important',
    },
    ".MuiPrivateTabIndicator-root-342": {
        display: "none !important",
    },
    deleteVideo: {
        width: 'max-content',
        justifyContent: 'flex-end'
    },

    perfectScrollbar: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit,
        // paddingBottom: theme.spacing.unit,
        maxHeight: 'inherit',
        background: 'rgb(255, 255, 255)',
        borderRadius: 4,
        '& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y': {
            opacity: 1
        },
        paddingBottom: 24
    },

    backIconRoot: {
        fill: theme.palette.text.secondary,
        fontSize: 24,
        opacity: 0.5,
        marginBottom: 3
    },
    dialogContent1: {
        padding: 0,
        maxHeight: '100%',
        marginTop: 74
    },
    dialogTitle: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        backgroundColor: 'white',
        '& > h6 > div': {
            minHeight: theme.spacing.unit * 7,
        },
        textTransform: 'capitalize',
        borderBottom: '1px solid rgb(226 226 226)',
        position: 'fixed',
        zIndex: 1001,
        top: 0,
        left: 0,
        right: 0
    },
    DeleteIconcss: {
        position: 'absolute',
        right: '20px',
        top: '10px',
    },
    addThumbnailBtn: {
        fontSize: 'small',
        // padding: '0px !important',
        marginBottom: '20px',
        cursor: 'pointer',
        display: "inline-block",
        color: "#333",
        '&:hover':{
            textDecoration: 'none',
            color: '#999',
        }
    },
    thumbnailTitle: {
        paddingBottom: '20px',
        display: 'block',
    },
    posRel:{
        position:'relative',
        display:'inline-block',
    },
    imgSethw:{
        width:'145px',
        height:'102px',
        borderRadius:'4px',
        // border:' 1px dashed rgba(153, 153, 153, 0.3);',
    },
    closeThumb:{
        position:'absolute',
        right:'-10px',
       top:'-10px', 
    },
    searchLabel:{
        fontSize: 16,
        fontWeight:400,
        lineHeight: '22px',
        marginBottom: 5,
    },
    panelTitle:{
        display: "block",
        borderBottom: "1px solid #efefef",
        padding: "15px 0 !important",
        marginBottom: 10,
    },
    customTextArea:{
        '&>:first-child':{
            marginTop: 0,
            borderRadius: 4,
            marginBottom: 18,
            '& textarea':{
              width: '95%',
              boxSizing: 'initial',
              padding: '6px'
            },
            '&>div:nth-of-type(1)':{
                marginTop: 0,
            }
        }
      }
});

enum FilterValues {
    status = 'status',
    published = 'PUBLISHED',
    contentType = 'contentType',
    question = 'question',
    MMCQ = 8
}

interface AddDetailsVideoProps extends WithStyles<typeof styles> {
    history: any,
    actionType: any,
    videoURL: string,
    // notesData: any,
    handleVideoDetailsData: Function,
    formData: any,
    content: any,
    formDataError: ContentFormDataError,
    type: any,
    subType: any,
    prevSubTypesState: any,
    setPageInContent: any,
    removeStyleInContent: any,
    tabState: any,
    isUploadModal: any,
    showVideo: any,
    tagsList: [],
    inSectionContent: any;
    setConceptAndChapter: Function,
    setTagsInContent: Function,
    updateCreateVideoState: Function,
    showMsg: Function,
    resetVideoModalState: Function,
    updateVideoStepState: Function,
    videoDetails: any,
    editRights: string[]

}
interface AddDetailsVideoState {
    isUploadStart: boolean,
    title: string,
    description: string,
    pageState: any,
    componentAddCounter: any,
    componenetStoreArray: any,
    isDisabled: boolean,
    touched: any,
    errorMessage: any,
    deletePopUpDialog: any,
    isOtherOptionsOpen: boolean;
    isFixedAttempts: boolean;
    courses: any;
    loadingTemplates: boolean;
    templates: any;
    languages: any;
    viewDetailId: string;
    selectedTemplateId: string;
    selectedSectionId: string;
    courseName: string;
    selectQuestionDialogOpen: boolean,
    selectedQuestionCount: any,
    isCollaspableAllowed: any,
    mathEditor: any,
    selectQuestionDialogData: {
        sectionId: string;
        subSectionId: string;
        quesCodeAllowed: number;
        noOfQuestions: number;
        replaceIndex: number;
        replaceIndexJ: number;
        content_Id: string;
        addedQuestions: any;
    };
    selectedTempQuestions: any;
    chooseLibraryKey: any,
    selectedTrackedQuestionIds: any;
    data: any;
    thumbnailDialogOpen: boolean;
    hours: number;
    inSectionContentVideo: any;
    tags: any[],
    subjects: any[];
    videoDuration: any;
    secondarySubjects: any;
    thumbnailURLAt: number;
    isVideoDelete: boolean;
    existingQuestions: any[];
    deleteThumbnailDialogOpen: boolean;
    suggestedQuestions: ContentData[];
}

const initialPageState = {
    title: '',
    searchId: '',
    content_Id: '',
    description: '',
    instruction: '',
    showHint: false,
    showSolution: false,
    attempt: false,
    showQuestionAtTime: '00:00:00',
    hours: 0,
    isVideoDelete: false,
}

const preSelectedFilterContent: any = {
    contentMenu: "all",
    goalsDriller: {},
    contentFilterData: [{
        filterValue: FilterValues.contentType,
        isSelected: true,
        disabled: false,
        filters: [{
            filterValue: FilterValues.question,
            isSelected: true,
            disabled: false,
            filters: []
        }
        ]
    },
    {
        filterValue: FilterValues.status,
        isSelected: true,
        disabled: false,
        filters: [{
            filterValue: FilterValues.published,
            isSelected: true,
            filters: []
        }],
    }
    ]
}

class AddDetailsVideo extends Component<AddDetailsVideoProps, AddDetailsVideoState> {
    constructor(props: AddDetailsVideoProps) {
        super(props);
        const { formData = {} }: { formData: any } = props;
        const totalQuestions = formData.pages ? formData.pages.length : 0

        this.state = {
            title: formData.title || '',
            description: formData.description || '',
            pageState: formData.pageState || {},
            thumbnailDialogOpen: false,
            isUploadStart: false,
            componentAddCounter: totalQuestions,
            componenetStoreArray: Array.from({ length: totalQuestions }, (v, i) => i + 1),
            isDisabled: true,
            touched: {},
            errorMessage: {},
            loadingTemplates: false,
            isOtherOptionsOpen: false,
            isFixedAttempts: false,
            deletePopUpDialog: false,
            selectedQuestionCount: 0,
            courses: [],
            templates: [],
            languages: [],
            viewDetailId: "",
            selectedTemplateId: "",
            selectedSectionId: "",
            courseName: "",
            mathEditor: null,
            chooseLibraryKey: '',
            selectQuestionDialogOpen: false,
            selectQuestionDialogData: {
                sectionId: "",
                subSectionId: "",
                quesCodeAllowed: -1,
                noOfQuestions: 0,
                replaceIndex: -1,
                replaceIndexJ: -1,
                content_Id: "",
                addedQuestions: []
            },
            selectedTempQuestions: [],
            selectedTrackedQuestionIds: {},
            data: [],
            tags: formData.tags || [],
            isCollaspableAllowed: {},
            hours: 0,
            inSectionContentVideo: [...this.props.inSectionContent],
            subjects: formData.subjects || [],
            videoDuration: '00:00:00',
            secondarySubjects: formData.secondarySubjects || [],
            thumbnailURLAt: 10,
            isVideoDelete: false,
            existingQuestions: [],
            deleteThumbnailDialogOpen: false,
            suggestedQuestions: [],
        }
        this.getSearchResults = _.debounce(this.getSearchResults, 500);
    }

    componentDidMount = () => {
        const { formData } = this.props;
        const { tagsList, prevSubTypesState } = this.props;
        const { inSectionContentVideo, tags, subjects, pageState, secondarySubjects,
            title = '',
            description = '',
            errorMessage: {
                title: titleError = '',
                description: descriptionError = ''
            }
        } = this.state;
        let successfulQuestions = 0;
        if (formData.videoUrl && formData.videoUrl.length) {
            this.props.updateVideoStepState({ ...inSectionContentVideo[0], state: statusType.success })
        }
        if (tags && tags.length) {
            const validationsCopy = JSON.parse(JSON.stringify(inSectionContentVideo));
            const result = this.validateTags(validationsCopy, tagsList, tags);
            this.props.setTagsInContent({ ...result[3] })
        }
        if (subjects.length) {
            this.props.setConceptAndChapter({ ...inSectionContentVideo[2], state: statusType.success });
        }
        if (pageState && Object.keys(pageState).length) {
            const newPageStatusType: any[] = []
            const existingPageQuestions: any[] = [];
            Object.keys(pageState).forEach((page: any, index) => {
                const setStatusTypes = {
                    title: `Page ${index + 1}`,
                    previousState: 4,
                    key: 'createVideos',
                    state: (page.instruction && page.instruction.length) ? statusType.success : statusType.edit,
                    visible: true,
                    subType: []
                };
                (setStatusTypes.state === statusType.success) && successfulQuestions++
                newPageStatusType.push(setStatusTypes);
                existingPageQuestions.push(pageState[page]);
            });
            this.setState((prevState) => ({
                existingQuestions: [
                    ...prevState.existingQuestions,
                    ...existingPageQuestions

                ]
            }))
            this.props.setPageInContent([...prevSubTypesState, ...newPageStatusType]);
        }
        if (
            title.length && description.length
            && !titleError.length && !descriptionError.length
            && (successfulQuestions === Object.keys(pageState).length)
            && inSectionContentVideo[1].state !== 1
        ) {
            this.props.updateCreateVideoState({ state: statusType.success });
        }
    }

    componentDidUpdate = (prevProps: any, prevState: any) => {
        if (prevProps.inSectionContent[1] !== this.props.inSectionContent[1]) {
            this.updateVideoContentStepperState();
        }
    }

    getThumbnailURL = (url?: any) => {
        const { thumbnailURLAt } = this.state;
        const { formData: { videoUrl } } = this.props;
        let fileUrl = videoUrl || url;
        fileUrl = JSLZString.decompressFromEncodedURIComponent(fileUrl) || '';
        const key = getKeyFromStreamUrl(fileUrl);
        videoUploadService.uploadThumbnail(key, thumbnailURLAt).then((response) => {
            this.setState({ thumbnailURLAt: 10 });
            this.props.handleVideoDetailsData({ thumbnailUrl: response })
        }).catch(() => { });

    }

    handleTitleValidations = (title: any) => {
        if (title.length < 5) {
            this.setState({
                errorMessage: {
                    ...this.state.errorMessage,
                    title: 'it should be minimum 5 characters'
                }
            }, () => {
                this.props.handleVideoDetailsData({ pageError: this.state.errorMessage })
                this.props.updateCreateVideoState({ state: 3 })
            })
        }
        else {
            this.setState({
                errorMessage: {
                    ...this.state.errorMessage,
                    title: ''
                }
            }, () => this.props.handleVideoDetailsData({ pageError: this.state.errorMessage }))

        }

    }

    handleDescriptionValidations = (description: any) => {
        if (description.length > 180) {
            this.setState({
                errorMessage: {
                    ...this.state.errorMessage,
                    description: 'It should be less than 180 characters'
                }
            }, () => {
                this.props.handleVideoDetailsData({ pageError: this.state.errorMessage })
                this.props.updateCreateVideoState({ state: statusType.edit })
            })
        } else if (description.length < 1) {
            this.setState({
                errorMessage: {
                    ...this.state.errorMessage,
                    description: 'description is required'
                }
            }, () => {
                this.props.handleVideoDetailsData({ pageError: this.state.errorMessage })
                this.props.updateCreateVideoState({ state: statusType.edit })
            })
        } else {
            this.setState({
                errorMessage: {
                    ...this.state.errorMessage,
                    description: ''
                }
            }, () => this.props.handleVideoDetailsData({ pageError: this.state.errorMessage }))

        }

    }

    updateVideoContentStepperState = () => {
        const { prevSubTypesState, inSectionContent } = this.props;
        const {
            title = '',
            description = '',
            errorMessage: {
                title: titleError = '',
                description: descriptionError = ''
            }
        } = this.state;
        if (
            title.length && description.length
            && !titleError.length && !descriptionError.length
            && (!prevSubTypesState.length || prevSubTypesState.every((page: any) => page.state === statusType.success))
            && inSectionContent[1].state !== statusType.success
        ) {
            this.props.updateCreateVideoState({ state: statusType.success });
        } else if (
            (inSectionContent[1].state === statusType.success)
            && prevSubTypesState.length
            && !prevSubTypesState.every((page: any) => page.state === statusType.success)) {
            this.props.updateCreateVideoState({ state: statusType.edit });
        }
    }

    validateVideoContentDetails = () => {
        const { prevSubTypesState } = this.props;
        const {
            title = '',
            description = '',
            errorMessage: {
                title: titleError = '',
                description: descriptionError = ''
            }
        } = this.state;
        if (
            title.length && description.length
            && !titleError.length && !descriptionError.length
            && (!prevSubTypesState.length || prevSubTypesState.every((page: any) => page.state === statusType.success))) {
            this.props.updateCreateVideoState({ state: statusType.success });
        }
    }

    handleInputChange = (field: any) => (event: any) => {
        const value = event.target.value;
        this.setState({ ...this.state, [field]: value }, () => {
            const { title, description } = this.state;
            (field === 'title') && this.handleTitleValidations(title);
            (field === 'description') && this.handleDescriptionValidations(description);
            this.validateVideoContentDetails();
            this.props.handleVideoDetailsData({ [field]: value });

        })
    };

    handlePageState = (count: number, key: any, field: any, isCheckBox: boolean = false, isTime: boolean = false) => (event: any) => {
        const value = isTime ? event : (isCheckBox ? event.target.checked : event.target.value);
        const { prevSubTypesState } = this.props;
        this.setState(prevState => ({
            pageState: {
                ...prevState.pageState,
                [key]: {
                    ...prevState.pageState[key],
                    [field]: value,
                }
            }
        }), () => {
            const { pageState: newPageState } = this.state;
            this.props.handleVideoDetailsData({ pageState: newPageState });
            if (field === 'instruction') {
                if ((newPageState[key]['instruction'] && newPageState[key]['instruction'].length)) {
                    const newSubStypeState = prevSubTypesState.map((page: any) => {
                        if (page.title === `Page ${count}`) {
                            return {
                                ...page,
                                state: statusType.success
                            }
                        }
                        return page;
                    })
                    this.props.setPageInContent(newSubStypeState)
                } else {
                    const newSubStypeState = prevSubTypesState.map((page: any) => {
                        if (page.title === `Page ${count}`) {
                            return {
                                ...page,
                                state: statusType.edit
                            }
                        }
                        return page;
                    })
                    this.props.setPageInContent(newSubStypeState)
                }
            }
        })
    };

    isError = (fields: any) => {
        const { errorMessage } = this.state;
        if (errorMessage[fields]) {
            return true;
        }
        return false;
    }

    handleAddPage = (): void => {
        const { componentAddCounter } = this.state;
        const { prevSubTypesState } = this.props;
        if (componentAddCounter + 1 !== 0) {
            this.setState({
                isDisabled: false
            });
        }
        this.setState({
            componentAddCounter: componentAddCounter + 1,
        }, () => {
            const { componenetStoreArray, componentAddCounter, pageState } = this.state;
            this.setState({
                componenetStoreArray: [
                    ...componenetStoreArray,
                    componentAddCounter
                ],
                pageState: {
                    ...pageState,
                    [`question${componentAddCounter}`]: {
                        ...pageState[`question${componentAddCounter}`],
                        description: '',
                        instruction: ''
                    }
                }
            }, () => {
                const newPageState = this.state.pageState
                this.props.handleVideoDetailsData({ pageState: newPageState });
                const pageLength = Object.keys(newPageState).length;
                const setStatusTypes = {
                    title: `Page ${pageLength}`,
                    previousState: 4,
                    key: 'createVideos',
                    state: statusType.none,
                    visible: true,
                    subType: []
                };
                this.props.setPageInContent([...prevSubTypesState, setStatusTypes]);
            });

        });
    }

    handleDeletePage = (key: any): void => {
        const { prevSubTypesState } = this.props;
        const { componentAddCounter, componenetStoreArray, existingQuestions, pageState, chooseLibraryKey } = this.state;
        const componenetStoreArrayCopy = componenetStoreArray;
        componenetStoreArrayCopy.pop();
        const newExistingQuestionsList = existingQuestions.filter((question: any) => question.contentId !== pageState[key].contentId);
        const newArr = componenetStoreArrayCopy.map((element: any, index: any): any => {
            return index + 1;
        });
        if (key === chooseLibraryKey) {
            const indexValue = Object.keys(pageState).indexOf(chooseLibraryKey);
            let newKey = '';
            if (indexValue === Object.keys(pageState).length - 1) {
                newKey = Object.keys(pageState)[indexValue - 1];
            }
            this.setState({
                chooseLibraryKey: newKey,
            })
        }

        let tempPageStateArray = { ...pageState };
        delete tempPageStateArray[key];
        let newPageState: any = {};
        let counter = 1
        for (const [key, value] of Object.entries(tempPageStateArray)) {
            newPageState = {
                ...newPageState,
                [`question${counter}`]: value
            }
            counter++
        }

        const updatedCounter = updater("DECREMENT", componentAddCounter)
        this.setState({
            componenetStoreArray: newArr,
            componentAddCounter: updatedCounter,
            pageState: newPageState,
            existingQuestions: [...newExistingQuestionsList]
        }, () => {
            const newSubTypesState = prevSubTypesState
                .filter((subPages: any) => subPages.title !== `Page ${key.split('question')[1]}`)
                .map((state: any, index: number) => {
                    return {
                        ...state,
                        title: `Page ${index + 1}`
                    }
                })
            this.props.handleVideoDetailsData({ pageState: newPageState });
            this.props.removeStyleInContent(newSubTypesState);
        });

    }

    handleContentSelect = (selectedQuestions: any) => {

        const firstTickQuestion = selectedQuestions[0];
        if (selectedQuestions.length > 0) {
            this.setState({
                selectedQuestionCount: selectedQuestions.length,
            });
        } else {
            this.setState({
                selectedQuestionCount: 0,
            });

        }
        this.setState({ selectedTempQuestions: firstTickQuestion });
    }

    handleContentSelectAll = (selectedQuestions: any) => {
        this.handleTrackSelectedQuestionIds(selectedQuestions)
        this.setState({
            selectedTempQuestions: selectedQuestions,
            selectedQuestionCount: selectedQuestions.length
        });
    }
    handleCheckContentExist = (content_Id: string) => {
        const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state
        const { subSectionId: selectedSubSectionId, content_Id: selectedContentId, addedQuestions, quesCodeAllowed: selectedQuestCode, replaceIndex } = selectQuestionDialogData
        const addedContent_Ids: any = new Set(addedQuestions.map((content: any) => content.content_Id))
        addedContent_Ids.delete(selectedContentId)
        const key = content_Id
        let isContentExist = false;
        if (selectedTrackedQuestionIds.hasOwnProperty(key)) {
            const quesCodeAllowed = selectedTrackedQuestionIds[key].quesCodeAllowed
            const subSectionId = selectedTrackedQuestionIds[key].subSectionId
            if (replaceIndex !== -1) {
                if (content_Id !== selectedContentId && addedContent_Ids.has(content_Id)) {
                    isContentExist = true
                }
            } else {
                if (selectedQuestCode == quesCodeAllowed) {
                    if (selectedSubSectionId !== subSectionId) {
                        isContentExist = true
                    }
                }
            }

        }
        return isContentExist
    }

    handleBackToTestpaperClick = (evt: any) => this.setState({ selectQuestionDialogOpen: false });

    handleTrackSelectedQuestionIds(selectedQuestions: any) {
        const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state;
        const { quesCodeAllowed, subSectionId } = selectQuestionDialogData
        selectedQuestions.forEach((question: any) => {
            const key = question.content_Id
            if (!selectedTrackedQuestionIds.hasOwnProperty(key)) {
                selectedTrackedQuestionIds[key] = {
                    quesCodeAllowed,
                    subSectionId,
                    content_Id: question.content_Id
                }
            }
        });
        this.setState({ selectedTrackedQuestionIds });
    }

    handleReplaceQuestion = (keyName: any) => {
        this.handleDeleteQuestions(keyName);
        this.handleChooseFromLibrary(keyName);

    }

    handleAddContentClick = () => {
        let { selectedTempQuestions, chooseLibraryKey, pageState, data, existingQuestions } = this.state;
        let newPageState = { ...pageState };
        const newQuestion = {
            ...initialPageState,
            title: selectedTempQuestions.title,
            content_Id: selectedTempQuestions.content_Id,
            contentId: selectedTempQuestions.contentId
        }
        newPageState[chooseLibraryKey] = newQuestion;
        this.setState({
            data: data,
            pageState: newPageState,
            selectQuestionDialogOpen: false,
            selectedTempQuestions: [],
            existingQuestions: [...existingQuestions, newQuestion]
        }, () => this.props.handleVideoDetailsData({ pageState: newPageState }));

    };

    handleSuggestedQuestionClick = (pageNameKey: any, selectedQuestion: any) => {
        let { pageState, existingQuestions } = this.state;
        let newPageState = { ...pageState };
        const newQuestion = {
            ...initialPageState,
            title: selectedQuestion.title,
            content_Id: selectedQuestion.content_Id,
            contentId: selectedQuestion.contentId
        }
        newPageState[pageNameKey] = newQuestion;
        this.setState({
            pageState: newPageState,
            existingQuestions: [...existingQuestions, newQuestion]
        }, () => this.props.handleVideoDetailsData({ pageState: newPageState }));
    }

    handleDeleteQuestions = (deleteId: any) => {
        const { pageState, existingQuestions } = this.state;
        const newExistingQuestionsList = existingQuestions.filter((question: any) => question.contentId !== pageState[deleteId].contentId);
        this.setState({
            pageState: {
                ...pageState,
                [deleteId]: {
                    ...initialPageState,
                }
            },
            existingQuestions: [...newExistingQuestionsList]
        });

    }

    handleCloseDialog = () => {
        this.setState({
            deletePopUpDialog: false,
        })
    }

    handleDeletePageWithPopUp = (pageKey: any) => {
        this.setState({
            deletePopUpDialog: false
        }, () => {
            this.handleDeletePage(pageKey)
        })

    }

    handleVideoSelect = () => {
        alert('llll');
        this.setState({
            isUploadStart: true,
        })
    }


    validateTags = function (inContentCopy: any, tagsList: any[], tags: any[]) {
        let requiredCount = 0
        let requiredMeet = 0
        tagsList.forEach(t => {
            if (t.isCompulsory) {
                requiredCount++;
                if (tags && tags.length > 0) {
                    tags.forEach((pt: any) => {
                        if (pt.relation && pt.relation.id && t._id == pt.relation.id) {
                            if (pt.values && pt.values[0]) {
                                requiredMeet++;
                            }
                        }
                    })
                }
            }
        });

        const status = requiredCount !== requiredMeet ? statusType.edit : statusType.success;
        inContentCopy[3].state = status;
        return inContentCopy;
    }

    setTags = (evt: any) => {
        const { tagsList } = this.props;
        const { inSectionContentVideo } = this.state
        const validationsCopy = JSON.parse(JSON.stringify(inSectionContentVideo));
        const stateUpdateOfTags = this.validateTags(validationsCopy, tagsList, evt);
        this.props.handleVideoDetailsData({ tags: evt });
        this.setState({
            tags: evt,
            inSectionContentVideo: stateUpdateOfTags
        }, () => {
            this.props.setTagsInContent({ ...this.state.inSectionContentVideo[3] })
        })
    }

    handleAddQuestionComponent = (count: any, pageKeyName: any) => {
        const { classes } = this.props;
        const { pageState, chooseLibraryKey, deletePopUpDialog } = this.state;
        const pageKey = `question${count + 1}`

        return (
            <div className={classes.root}>
                <Grid
                    container
                    spacing={8}
                    alignItems="center"
                    justify="space-between"
                    wrap="nowrap"
                    className={classes.mb1x}
                >
                    <Grid item xs="auto">
                        <Typography>
                            {`Q${count}`}
                        </Typography>
                    </Grid>
                    <Grid item xs style={{ maxWidth: '80%' }}>
                        <Grid
                            container
                            alignItems="center"
                            wrap="nowrap"
                            className={classes.questionInfo}
                        >
                            <Grid item xs="auto">
                                <ReorderIcon />
                            </Grid>
                            <Grid item xs={9}
                            >
                                <Typography variant="body1"
                                    classes={{ root: classes.questionParagraph }}
                                    dangerouslySetInnerHTML={{ __html: pageState[pageKeyName]['title'] ? pageState[pageKeyName]['title'] : "" }}
                                    noWrap>
                                </Typography>
                            </Grid>
                            <Grid item xs={3}
                                className={[classes.textAlignRight,classes.dInlineB].join(' ')}
                            >
                                <Typography variant="body1">
                                    ID: <span><MyPATLink to={`/content/preview/${pageState[pageKeyName]['content_Id']}question`} target="_blank">
                                        {pageState[pageKeyName]['contentId']}
                                    </MyPATLink></span>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs="auto" >
                        <Button
                            variant="outlined"
                            className={[classes.questionActionBtn, classes.noPosition].join(' ') + "  btn-delete"}
                            onClick={() => {
                                this.setState({
                                    deletePopUpDialog: true,
                                })
                            }
                            }
                        >
                            {/* <DeleteIcon /> */}
                            <img src="/assets/svg/myLibrary/delete-outline.svg" />
                        </Button>

                    </Grid>
                    <Grid item xs="auto">
                        <Button
                            variant="outlined"
                            className={[classes.questionActionBtn, classes.noPosition].join(' ') + "  btn-delete"}
                            onClick={() => this.handleReplaceQuestion(pageKeyName)}
                        >
                            {/* <ReplaceIcon /> */}
                            <img src="/assets/svg/learn/flipQuestion.svg" />
                        </Button>
                    </Grid>
                    <DeletePopUp
                        openDialog={deletePopUpDialog}
                        handleClose={this.handleCloseDialog}
                        deleteFunction={() => this.handleDeletePageWithPopUp(pageKeyName)}
                    />
                </Grid>
            </div>
        );
    }

    /**to updated the time in datepicker */

    setStartDate = (date: any) => {
        this.setState({ hours: date })
    }

    //----------------------------------------------------------------------------->
    handleChooseFromLibrary = (pageKeyName: any) => {
        let goalsDriller: any = {};
        this.setState({
            chooseLibraryKey: pageKeyName,
            selectedQuestionCount: 0,
        })
        this.setState({
            selectQuestionDialogOpen: true,
        })
    }

    setMathInstance = (mathEditor: any) => {
        this.setState({ mathEditor })
    }

    withContent = () => {
        const {
            selectedQuestionCount
        } = this.state;

        let { selectQuestionDialogOpen, existingQuestions } = this.state;

        const otherDialogProps = {
            fullScreen: true
        };
        const { classes, type } = this.props;
        let { selectedTempQuestions, selectedTrackedQuestionIds } = this.state;
        return (
            <Dialog  {...otherDialogProps} open={selectQuestionDialogOpen}>

                <div style={{ width: 'auto' }}>
                    <DialogTitle classes={{ root: classes.dialogTitle }}>
                        <>
                            <Grid container justify="space-between" alignItems="center">
                                <Grid item xs="auto">
                                    <Typography
                                        color="textPrimary"
                                        variant="body1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={this.handleBackToTestpaperClick.bind(this)}
                                    >
                                        <BackIcon classes={{ root: classes.backIconRoot }} />
                                        <strong>Back to Study Material Notes</strong>
                                    </Typography>
                                </Grid>
                                <Grid item xs />
                                <Grid item xs="auto">
                                    <Typography variant="caption" inline>
                                        <b style={{ marginRight: '20px', fontSize: 16, }}>{selectedQuestionCount}/ 1 Selected</b>
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={selectedQuestionCount !== 1}
                                        onClick={() => this.handleAddContentClick()}
                                    >
                                        Add Content
                </Button>
                                </Grid>
                            </Grid>
                        </>
                    </DialogTitle>
                    <DialogContent classes={{ root: classes.dialogContent1 }}>
                        <PerfectScrollbar className={`dialog-content ${classes.perfectScrollbar}`}>
                            <WithContent
                                isInPopUp={true}
                                selectedQuestions={selectedTempQuestions}
                                selectedTrackedQuestionIds={selectedTrackedQuestionIds}
                                onContentSelect={this.handleContentSelect.bind(this)}
                                filterSelectedQuestion={existingQuestions}
                                onContentSelectAll={this.handleContentSelectAll.bind(this)}
                                onCheckContentExist={this.handleCheckContentExist.bind(this)}
                                selectedFilterContent={preSelectedFilterContent}
                                fromTestPaper={true}
                                type={type}
                                removeDisabilityFromCheckBox={true}
                                isSelectAllRequired = {false}
                                contentCreateOption={false}
                            />
                        </PerfectScrollbar>
                    </DialogContent>
                </div>
            </Dialog>

        )
    }

    onKeyPress = (event: any, pageNameKey: any) => {
        const { pageState, existingQuestions } = this.state;
        const searchText: any = _.get(pageState, `${pageNameKey}.searchId`, '').toUpperCase();
        if (event.key == 'Enter' && searchText.length > 3) {
            if (!existingQuestions.some((question: any) => question.contentId === searchText)) {
                contentService.list({ searchText, contentFilterData: preSelectedFilterContent.contentFilterData }, 1, 100).then((result: any) => {
                    if (result && result.length) {
                        
                        this.handleSuggestedQuestionClick(pageNameKey, result[0])
                    } else {
                        this.props.showMsg('Either content Id is not valid or it is a draft content', 'error')
                    }
                })
            } else {
                this.props.showMsg('Content Id already used', 'error');
            }
        }
    }

    getSearchResults = (searchText: string) => {
        if(!searchText) {
            // if search string is empty then set suggestions to empty
            this.setState({
              suggestedQuestions: []
            })
            return;
          }
        contentService.list({ searchText, contentFilterData: preSelectedFilterContent.contentFilterData }, 1, 5).then((result: any) => {
            if (result && result.length) {
                this.setState({
                    suggestedQuestions: result
                })
            } else {
                this.props.showMsg('Either content Id is not valid or it is a draft content', 'error')
            }
        })
        
    }

    suggestionSelection = (selectedSuggestion: ContentData, pageNameKey: string) => {
        const { pageState, existingQuestions } = this.state;
        if (!existingQuestions.some((question: any) => question.contentId === selectedSuggestion.contentId)) {
            if(selectedSuggestion.status === CONTENT_STATES.PUBLISHED) {
                this.handleSuggestedQuestionClick(pageNameKey, selectedSuggestion)
            } else {
                this.props.showMsg('Either content Id is not valid or it is a draft content', 'error')
            }
        } else {
            this.props.showMsg('Content Id already used', 'error');
        }
    }

    addPageComponent = (count: any = 0): any => {
        const { pageState, videoDuration, suggestedQuestions } = this.state;
        const { classes, formData, tabState } = this.props;
        const pageName = `Question ${count}`;
        const pageNameKey = `question${count}`;
        return (
            <>
                {/* <div className={classes.tabsAlign} style={{ paddingTop: '20px', }}>
                    <Typography
                        variant="h6"
                    >
                        {pageName}
                    </Typography>
                </div> */}
                <div>
                    {tabState === 3 &&
                        <div className={classes.tabsContainer}>
                            <div style={{ textAlign: 'right', display: 'block', }}>
                                <Button
                                    className={classes.tabsNotes}
                                    onClick={() => this.handleDeletePage(pageNameKey)}
                                >
                                    <div style={{ 'display': 'flex', 'flex-direction': 'row-reverse' }}>
                                        <CloseIcon />
                                    </div>

                                </Button>
                            </div>
                        </div>
                    }
                    {/* need to add css in this component*/}
                    {tabState === 1 &&
                        <div className={classes.tabsContainer}>
                            <div style={{ textAlign: 'left', display: 'block', marginBottom: '20px' }}>
                                {/* <Button
                                    className={classes.tabsNotes}
                                    onClick={() => this.handleDeletePage(pageNameKey)}
                                > */}
                                    <div >
                                        {/* <CloseIcon /> */}{pageName}
                                    </div>
                                {/* </Button> */}

                            </div>
                            {!(pageState[pageNameKey] && (pageState[pageNameKey]['title'] ||
                                pageState[pageNameKey]['description'])
                            ) ? (
                                    <div className={classes.tabsContainer2}>
                                        <Typography className={classes.searchLabel}>Search Question Id</Typography>
                                        <MyPATMultiSearch
                                            options={suggestedQuestions}
                                            labelKey="contentId"
                                            valueKey="_id"
                                            onChange={(suggestion: ContentData) => this.suggestionSelection(suggestion, pageNameKey)}
                                            values=""
                                            isSearchAble
                                            isCustomFilter
                                            filtredFunction={this.getSearchResults}
                                            name="search"
                                            placeholderText="Enter question id"
                                        />
                                        {/* <SearchField
                                            onKeyPress={(e: any) => this.onKeyPress(e, pageNameKey)}
                                            placeholder="Enter Question Id"
                                            className={classes.searchNotesinput}
                                            onChange={this.handlePageState(count, pageNameKey, 'searchId')}
                                            fullWidth
                                        /> */}


                                        <Typography variant="caption" className={classes.OrDivider}>
                                            <span className={classes.dividerBar}><b className={classes.orText}> OR </b></span>
                                        </Typography>

                                        <div className={classes.textAlignCenter}>

                                            <Button
                                                variant="contained"
                                                color="primary"
                                                className={classes.mb1x}
                                                onClick={() => this.handleChooseFromLibrary(pageNameKey)}
                                            >
                                                Choose from Library
															</Button>
                                        </div>

                                    </div>
                                ) : (
                                    <div>
                                        <div>
                                            {this.handleAddQuestionComponent(count, pageNameKey)}
                                        </div>
                                        <Typography
                                            variant="h6" style={{ fontSize: 16, fontWeight: 'normal', }}
                                        >
                                            Custom Description
                                    </Typography>
                                        <MyPATMathField
                                            variant='textarea'
                                            editorProps={{
                                                externalToolbarId: 'box',
                                                name: `description`,
                                                handleChange: this.handlePageState(count, pageNameKey, 'description'),
                                                setInstance: this.setMathInstance,
                                                editorId: pageNameKey,
                                                value: pageState[pageNameKey]['description'],
                                            }}
                                        />
                                        <Typography
                                            variant="h6" style={{ fontSize: 16, paddingTop: '20px', fontWeight: 'normal', }}
                                        >
                                            Add Instruction <span className={classes.mandatory}>*</span>
                                        </Typography>

                                        <MyPATMathField
                                            variant='textArea'
                                            editorProps={{
                                                externalToolbarId: 'box',
                                                name: `instruction`,
                                                handleChange: this.handlePageState(count, pageNameKey, 'instruction'),
                                                setInstance: this.setMathInstance,
                                                editorId: pageNameKey,
                                                value: pageState[pageNameKey]['instruction'],
                                            }}
                                        />
                                        <div style={{ 'display': 'flex', 'flexDirection': 'row', 'justifyContent': 'space-between' }}>
                                            <div>
                                                <Typography
                                                    variant="h6" style={{ fontSize: 16, paddingTop: '20px', fontWeight: 'normal', }}
                                                >
                                                    Attempt Question
                                                </Typography>
                                                <FormGroup row>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={pageState[pageNameKey]['attempt'] || false}
                                                                onChange={this.handlePageState(count, pageNameKey, 'attempt', true)}
                                                                value="attempt"
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Optional"
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div>
                                                <Typography variant="h6" style={{ fontSize: 16, paddingTop: '20px', fontWeight: 'normal', }}>
                                                    Addtional options for students
                                        </Typography>
                                                <FormGroup row>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={pageState[pageNameKey]['showSolution'] || false}
                                                                onChange={this.handlePageState(count, pageNameKey, 'showSolution', true)}
                                                                value="showSolution"
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Show solution"
                                                    />
                                                </FormGroup>
                                                <FormGroup row>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={pageState[pageNameKey]['showHint'] || false}
                                                                onChange={this.handlePageState(count, pageNameKey, 'showHint', true)}
                                                                value="showHint"
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Show hint"
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div>
                                                <Typography variant="h6" style={{ fontSize: 16, paddingTop: '20px', fontWeight: 'normal', }}>
                                                    Show question at below time
                                                </Typography>
                                                {videoDuration !== '00:00:00' && 
                                                <TimePicker
                                                    value={pageState[pageNameKey]['showQuestionAtTime'] || '00:00:00'}
                                                    onChange={this.handlePageState(count, pageNameKey, 'showQuestionAtTime', false, true)}
                                                    videoDuration={videoDuration}
                                                />
                                                }
                                            </div>
                                        </div>

                                    </div>
                                )
                            }
                        </div>}
                </div>
            </>
        )

    }

    handleAddConceptChapterFormChange = (key: any) => (updateFormData: any) => {
        const field = (key === 'primary') ? 'subjects' : 'secondarySubjects'
        const { inSectionContent } = this.props;

        this.setState((prevState) => ({
            ...prevState,
            [field]: JSON.parse(JSON.stringify(updateFormData))
        }), () => {
            const { subjects, secondarySubjects } = this.state;
            const newState = this.state[field]
            this.props.handleVideoDetailsData({ [field]: [...newState] })
            if (subjects.length) {
                this.props.setConceptAndChapter({ ...inSectionContent[2], state: statusType.success });
            }
            else {
                this.props.setConceptAndChapter({ ...inSectionContent[2], state: statusType.edit });
            }
        });

    }

    setThumbnailDialogOpen = () => {
        this.setState({ thumbnailDialogOpen: true });
    }

    setThumbnailDialogClose = () => {
        this.setState({
            thumbnailDialogOpen: false,
            thumbnailURLAt: 10,
        });

    };

    setThumbnailURLAt = (thumbnailURLAt: number) => {
        this.setState({ thumbnailURLAt: thumbnailURLAt })
    };

    handleVideoDuration = (seconds: any) => {
        const { pad } = this;
        const date = new Date(seconds * 1000)
        const hh = date.getUTCHours()
        const mm = date.getUTCMinutes()
        const ss = pad(date.getUTCSeconds())
        if (hh) {
            this.setState((prevState) => ({ ...prevState, videoDuration: `${hh}:${pad(mm)}:${ss}` }));
        } else if (mm) {
            this.setState((prevState) => ({ ...prevState, videoDuration: `00:${mm}:${ss}` }))
        } else this.setState((prevState) => ({ ...prevState, videoDuration: `00:00:${pad(ss)}` }))
    }

    pad = (string: any) => {
        return ('0' + string).slice(-2)
    }

    handlePopupClose = () => {
        this.setState({
            isVideoDelete: false,
        })

    }

    deleteVideo = () => {
        const { formData } = this.props;
        let { videoKey, completionPercent } = formData;
        completionPercent = completionPercent >= 25 ? completionPercent - 25 : completionPercent
        videoUploadService.deleteVideoService({videoKey, completionPercent, id: formData._id}).then(async (resData: any) => {
            if (resData.statusCode === 200) {
                this.setState({
                    isVideoDelete: false
                }, () => {
                    const { inSectionContentVideo } = this.state;
                    this.props.handleVideoDetailsData({ videoUrl: '', thumbnailUrl: '', videoKey: '' })

                    this.props.updateVideoStepState({ ...inSectionContentVideo[0], state: statusType.edit })
                })
                this.props.showMsg(resData.responseMessage, "success");
            } else {
                this.props.showMsg('Unable to delete Video', 'error');
            }
        }).catch(() => { });
    }

    handleSubmit = (videoUrl: string) => {
        const videoKey = getKeyFromStreamUrl(videoUrl);
        const { inSectionContentVideo } = this.state;
        this.props.handleVideoDetailsData({ videoUrl: videoUrl, videoKey })
        this.setState({
            isVideoDelete: false
        });
        this.getThumbnailURL(videoUrl);
        this.props.updateVideoStepState({ ...inSectionContentVideo[0], state: statusType.success })
        this.props.resetVideoModalState();

    }

    deleteThumbnail = () => {
        const { formData } = this.props;
        const { _id, thumbnailUrl } = formData
        this.setState({
            deleteThumbnailDialogOpen: false
        }, () => {
            if (thumbnailUrl && thumbnailUrl.startsWith('videos/thumbnail') ) {
                videoUploadService.deleteVideoService({thumbnailKey: thumbnailUrl , id: _id}).then((response: any) => {
                    if (response.statusCode === 200) {
                        this.props.handleVideoDetailsData({ thumbnailUrl: '' });
                    } else {
                        this.props.showMsg('Unable to delete thumbnail', 'error');
                    }
                }).catch(() => this.props.showMsg('Unable to delete thumbnail', 'error'))
            } else {
                this.props.handleVideoDetailsData({ thumbnailUrl: '' });
            }
        })
    }

    render = () => {
        const { title, componenetStoreArray, errorMessage, description, thumbnailDialogOpen, isVideoDelete, deleteThumbnailDialogOpen } = this.state;
        const { classes, formData, type, videoDetails, editRights } = this.props;
        const { content, subjects, secondarySubjects, tags, thumbnailUrl, videoUrl, _id } = formData;
       
        return (
            <>

                <MyPATExpansionPanel
                    isDisable={!editRights.includes('notes')}
                    hasExpandIcon={false}
                    variant="transpaprent"
                    sectionId="addDetails"
                    customCollapseTitle={
                        <>
                        <Grid className={classes.panelTitle}>Upload Video</Grid>
                            {videoUrl === '' || isVideoDelete ? <StudyVideoCreate dialogOpen={isVideoDelete} mode={VIDEO_UPLOAD_MODES.EDIT} videoId={_id}
                                submitVideo={this.handleSubmit}
                            />
                                : <>
                                    <Button
                                        variant="outlined" 
                                        className={classes.questionActionBtn + "  btn-delete"}
                                            onClick={() => {
                                                        this.setState({
                                                            isVideoDelete: true,
                                                        })
                                                    }
                                                    }  
                                    >
                                        {/* <DeleteIcon /> */}
                                        <img src="/assets/svg/myLibrary/delete-outline.svg" />
                                    </Button>

                                    <MyPatVideoPlayer width="500px" height="300px" videoURL={formData.videoUrl || ''}
                                        onDuration={(duration: any) => {
                                            this.handleVideoDuration(duration)
                                        }}
                                    />
                                </>}
                            <br />
                            <Typography variant="h6" >
                                Video Details
                        </Typography>
                        </>
                    }
                    fullWidthControl
                >{
                        isVideoDelete ? < DeletePopUp openDialog={isVideoDelete}
                            handleClose={this.handlePopupClose}
                            deleteText="Are you sure you want to delete this video permanently"
                            deleteTitle="Delete Video"
                            deleteFunction={this.deleteVideo} />
                            : ''
                    }
                    <div className={classes.tabsContainer}>
                        <div className={classes.tabsAlign}>
                        <Grid item xs={12} className={classes.customTextArea}>
                            <MyPATTextArea
                                name="title"
                                label="Title"
                                value={title}
                                onChange={this.handleInputChange('title')}
                                placeholder="Add title here"
                                // For error Handling ....
                                // onBlur={() => { this.isTouched('title'); }}
                                // autoFocus
                                errorText={errorMessage.title}
                                error={this.isError('title')}
                                required
                                fullWidthControl
                                multiline
                            />
                        </Grid>
                        <Grid item xs={12} className={classes.customTextArea}>
                            <MyPATTextArea
                                name="description"
                                label="Description"
                                value={description}
                                onChange={this.handleInputChange('description')}
                                placeholder="Describe the title and its purpose..."
                                errorText={errorMessage.description}
                                error={this.isError('description')}
                                required
                                fullWidthControl
                                rows="5"
                                multiline
                                inputProps={{
                                    maxlength: 180
                                }}
                                helperText={`${description.length}/${180}`}
                            />
                            </Grid>

                            <span className={classes.thumbnailTitle}> Thumbnail </span>

                            <Link className={classes.addThumbnailBtn}
                                onClick={this.setThumbnailDialogOpen}>
                                Add a thumbnail
                            </Link>
                            {
                                deleteThumbnailDialogOpen ? < DeletePopUp openDialog={deleteThumbnailDialogOpen}
                                    handleClose={() => this.setState({ deleteThumbnailDialogOpen: false })}
                                    deleteText="Are you sure you want to delete this thumbnail permanently"
                                    deleteTitle="Delete Thumbnail"
                                    deleteFunction={this.deleteThumbnail} />
                                    : ''
                            }
                            <MyPatThumbnail onCloseThumbnail={this.setThumbnailDialogClose}
                                open={thumbnailDialogOpen}
                                videoURL={formData.videoUrl || ''} style={{ textAlign: 'left', display: 'block', }}
                                setThumbnailURLAt={this.setThumbnailURLAt}
                                getThumbnailURL={this.getThumbnailURL}
                                thumbnailTime={thumbnailUrl}
                            />
                            {
                              (thumbnailUrl && thumbnailUrl.length) ? (

                            <span className={classes.posRel}>
                                <img src={getThumbnailSource(thumbnailUrl)} className={classes.imgSethw} alt="Video thumbnail" />
                                {
                                <a href="javascript:void();" className={classes.closeThumb}>
                                    <img src="/assets/svg/learn/close_thumb.svg" onClick={() => this.setState({ deleteThumbnailDialogOpen: true })} />
                                </a>
                                }
                            </span>
                                ) : <img src="/assets/svg/thumbnail-placeholder.svg" className={classes.imgSethw} alt="Video thumbnail" />
                            }
                        </div>
                    </div>

                    {
                        componenetStoreArray.map((count: any) => {
                            return this.addPageComponent(count)
                        })
                    }

                    <div className={classes.addButtonAlign}>

                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.addPageMore}
                            onClick={() => this.handleAddPage()}
                        >
                            + Add question
                        </Button>
                    </div>

                </MyPATExpansionPanel>
                <AddConceptOrChapter
                    isDisable={!editRights.includes('syllabus')}
                    sectionId="addConceptAndChapters"
                    formData={_.isUndefined(subjects) ? [] : JSON.parse(JSON.stringify(subjects))}
                    handleFormChange={this.handleAddConceptChapterFormChange('primary')}
                    allowSecondarySubjects
                    secondarySubjects={_.isUndefined(secondarySubjects) ? [] : JSON.parse(JSON.stringify(secondarySubjects))}
                    handleSecondarySubjectChange={this.handleAddConceptChapterFormChange('secondary')}
                    contentType={CONTENT_TYPE.VIDEO}
                />
                <AddExtraTags
                    isDisable={!editRights.includes('tags')}
                    formData={_.isUndefined(tags) ? [] : JSON.parse(JSON.stringify(tags))}
                    handleFormChange={this.setTags}
                    contentType={type}
                    defaultExpanded={true}
                />
                {
                    this.withContent()
                }
            </>
        );
    }
};

const mapStateToProps = (state: any) => {
    return {
        inSectionContent: _.get(state, 'videoDetailsInContentReducers', {}),
        prevSubTypesState: _.get(state, 'videoDetailsInContentReducers[1].subType', {}),
        tabState: _.get(state, 'wrapperTabsReducers.activeTab', 1),
        isUploadModal: _.get(state, 'showVideoModalReducers.openModal', false),
        showVideo: _.get(state, 'videoUploadedReducers.showVideo', false),
        videoURL: state.videoCreateContent.videoURL,
        tagsList: _.get(state, 'mylibraryData.contentTags.list', []),
        videoDetails: state.videoCreateContent.videoDetails,
        editRights: _.get(state, 'questionCreate.editRights', [])

    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    setPageInContent: videoDetailsActions.addSubTypes,
    setConceptAndChapter: videoDetailsActions.addConceptAndChapter,
    removeStyleInContent: videoDetailsActions.removeSubTypes,
    setTagsInContent: videoDetailsActions.addExtraTags,
    updateCreateVideoState: videoDetailsActions.updateCreateVideoState,
    showMsg: showMsg,
    resetVideoModalState: videoActions.resetVideoModalState,
    updateVideoStepState: videoDetailsActions.updateVideoStepState,
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddDetailsVideo));